// src/components/WalletSecurity/WalletSecurityFaq.jsx
// Capa educativa de seguridad "for dummies" — el PILAR del producto (plan §2).
// Responde, en simple y honesto, las dudas que frenan a la gente con wallets.
// Tono StoryBrand: el usuario es el héroe; Bitplify es el guía que le quita el miedo.
// Componente autocontenido y reutilizable (Centro de Seguridad, modal de login, etc.).
import React, { useState } from 'react';
import { FiShield, FiKey, FiHome, FiLifeBuoy, FiLock, FiChevronDown } from 'react-icons/fi';
import './WalletSecurityFaq.css';

// Las preguntas que SÍ o SÍ hay que responder (plan §2). El texto enfatiza con
// <strong> la idea-ancla de cada respuesta.
const QA = [
  {
    Icon: FiShield,
    q: '¿Es seguro crear o conectar una wallet acá?',
    a: (<>Sí. Una wallet es como tu propia <strong>caja fuerte digital</strong>: vos tenés la única llave.
        Ni Bitplify ni nadie puede sacar tu plata. Por eso es <strong>más</strong> seguro que dejarla en una
        empresa que la custodia por vos.</>),
  },
  {
    Icon: FiLock,
    q: 'Si conecto mi wallet, ¿Bitplify puede vaciarla?',
    a: (<>No. Conectarte solo <strong>firma un mensaje</strong> que prueba que sos vos — como mostrar tu firma.
        <strong> Firmar para entrar ≠ darnos permiso de mover tu plata.</strong> Eso es otra cosa, y si alguna
        vez hiciera falta autorizar un movimiento, te lo mostramos clarito antes de firmar.</>),
  },
  {
    Icon: FiHome,
    q: '¿Qué es la autocustodia (self-custody)?',
    a: (<>Que la plata es <strong>tuya de verdad</strong>: vive en tu wallet, no en nuestra empresa.
        Si Bitplify desapareciera mañana, tu plata <strong>sigue siendo tuya</strong>. Tu plata, tu llave.</>),
  },
  {
    Icon: FiLifeBuoy,
    q: '¿Qué pasa si pierdo el teléfono o el acceso?',
    a: (<>No la perdés. Tu wallet se recupera con tu <strong>passkey</strong> (la huella/Face ID de tu teléfono)
        y, además, con <strong>recuperación social</strong>: personas o dispositivos de confianza que vos elegís
        para volver a entrar. Te guiamos paso a paso cuando creás la wallet.</>),
  },
  {
    Icon: FiKey,
    q: '¿Por qué el escrow es seguro si nadie custodia?',
    a: (<>Cuando llegue el escrow, los fondos quedan en un contrato que <strong>necesita 2 de 3 firmas</strong>
        para moverse. Bitplify tiene <strong>solo 1</strong> — nunca puede mover tu plata por su cuenta.
        Hoy todavía no está activo; cuando lo esté, te lo explicamos igual de claro.</>),
  },
];

export default function WalletSecurityFaq({ defaultOpen = 0 }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="wsf">
      {QA.map(({ Icon, q, a }, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className={`wsf-item ${isOpen ? 'open' : ''}`}>
            <button
              type="button"
              className="wsf-q"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? -1 : i)}
            >
              <span className="wsf-q-ic"><Icon /></span>
              <span className="wsf-q-text">{q}</span>
              <FiChevronDown className="wsf-q-chevron" />
            </button>
            <div className="wsf-a" hidden={!isOpen}>
              <p>{a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
